import { BaseState, StateManager } from '@app/store/shared';
import { createReducer, on } from '@ngrx/store';
import { News } from '../models';
import { newsActions } from '../actions/news.actions';

export type NewsState = BaseState<News[]>;

const initialState: NewsState = StateManager.initial();

export const newsReducer = createReducer(
    initialState,
    on(newsActions.getNews, (state): NewsState => ({ ...state, ...StateManager.setLoadingInitOnly(state) })),
    on(newsActions.getNewsSuccess, (state, { news }): NewsState => ({ ...state, ...StateManager.setLoaded(state, news) })),
    on(newsActions.getNewsError, (state): NewsState => ({ ...state, ...StateManager.setError(state) })),

    on(newsActions.clear, (): NewsState => ({
        ...initialState,
    })),
);
